import React from "react";
import SEO from "./SEO";
import Header from "./Header";
import Footer from "./Footer";
import ServiceSide from "./ServiceSide";
import { NavLink } from "react-router-dom";

function Services() {
  return (
    <>
      <SEO
        title="Website Design & Development Services | Custom Web Solutions – Moironix"
        description="Moironix Offers Responsive Website Design, E-commerce Development, and Custom Web Solutions. Get a Fast, Secure, and SEO-Friendly Website Today!"
        keywords="Website Design and Development, Responsive Website Design, Ecommerce Website Development Cost, Website Redesign Services, Website Speed Optimisation Services, Landing Page Design and Development, Website Design Company, Website Development Services, Web Design and Development, Ecommerce Website Development, Custom Website Design"
      />
      <Header />
      <div className="prt-page-title-row style1">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="banner-vertical-block" />
                  <div className="page-title-heading">
                    <h2 className="title">Web Design & Development</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <NavLink title="Homepage" to="/">
                        Home
                      </NavLink>
                    </span>
                    <span className="action">Web Design & Development</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <div className="site-main">
          <div className="prt-row sidebar prt-sidebar-left clearfix">
            <div className="container">
              <div className="row">
                <div className="widget-area sidebar-left prtcol-bgcolor-yes prt-bg prt-left-span bg-base-grey">
                  <ServiceSide />
                </div>
                <div className="col-lg-8 content-area">
                  <div className="prt-service-single-content-area">
                    <div className="prt_fatured_image-wrapper mb-40 res-575-mb-20">
                      <img
                        width={859}
                        height={440}
                        className="img-fluid"
                        src="images/d1.jpeg"
                        alt="services-1"
                      />
                    </div>
                    <div className="prt-service-description">
                      <h3>Web Design & Development</h3>
                      <p>
                        We specialize in creating stunning, responsive websites
                        that elevate your online presence. Our web design and
                        development services are crafted to meet your unique
                        needs, delivering exceptional user experiences
                      </p>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <ul className="service-detail-list">
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Custom Website Design
                              </div>
                            </li>
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Responsive Design
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  UI/UX Design
                                </div>
                              </li>
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Graphic Design
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Full-Stack Development
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  E-commerce Solutions
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  SEO-Friendly Development
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Content Management Systems (CMS)
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <Footer />
    </>
  );
}

export default Services;
